import { useEffect, useState } from "react";
import styles from "./styles.module.css";
import HistoryIcon from "@mui/icons-material/History";
import styled from "styled-components";
import {
  buscarDetailHistorico,
  buscarHistorico,
  downloadAnexoHistorico,
} from "../../../services/api-planejamento-tributario.service";
import DownloadIcon from "@mui/icons-material/Download";


const Icon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.3s ease-in-out;
  transform: ${({ open }) => (open ? "rotate(180deg)" : "rodate(0)")};
`;

const ContainerTimeLine = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #e2f2ff;
  border-radius: 8px;
  padding: 1rem;
  width: 100%;
  max-height: ${({ open }) => (open ? "55rem" : "0")};
  transition: all 0.3s ease-in-out;
  transform-origin: top;
  transform: ${({ open }) => (open ? "scaleY(1)" : "scaleY(0)")};
  overflow-y: scroll;
`;

const ModuleType = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #e2f2ff;
  border-radius: 8px;
  padding: 1rem;
  background-color: #fff;
  height: 4rem;

  &:hover {
    background-color: #f5f5f5;
    cursor: pointer;
  }
`;

const ContainerModule = styled.div`
  display: flex;
  gap: 1rem;
  flex-direction: column;
  background-color: #fff;
  border-radius: 8px;
  width: 100%;
  max-height: ${({ open }) => (open ? "60%" : "0")};
  transition: all 0.3s ease-in-out;
  transform-origin: top;
  transform: ${({ open }) => (open ? "scaleY(1)" : "scaleY(0)")};
  overflow-y: scroll;
  box-shadow: inset 0px 4px 10px rgba(0, 0, 0, 0.2);
  padding: 0.5rem;
  margin-block: ${({ open }) => (open ? "1rem" : "0")};
`;

const ModuleTimeline = ({ tipoHistorico, dtCadastro, idHistorico }) => {
  const [openDetail, setOpenDetail] = useState(false);
  const [dataDetail, setDataDetail] = useState();
  const [downloadedAquivo, setDownloadedAquivo] = useState();

  const typesWithDetail = [
    "Alteração solicitada",
    "Usuário Aprovado",
    "Usuário Reprovado",
    "Resposta",
    "Contrato Enviado",
    "Contrato Assinado",
    "Contrato Alterado",
    "Contrato disponível para download",
    "Data limite de assinatura alterada",
    "Nova data limite de assinatura",
    "Contrato Recusado",
    "Contrato Cancelado Manualmente",
  ];

  const formatedData = (date) => {
    const regex = /(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})/;
    const match = date.match(regex);

    if (match) {
      const [_, ano, mes, dia, hora, minuto] = match;

      const dataFormatada = `${dia}/${mes}/${ano} - ${hora}h${minuto}`;
      return dataFormatada;
    } else {
      return "Formato de data inválido";
    }
  };

  const handleDownload = async (idDadoHistorico) => {
    try {
      const dataDownload = await downloadAnexoHistorico(idDadoHistorico);
      setDownloadedAquivo(dataDownload);

      const file = dataDownload.data.anexo.data;

      if (file) {
        const contentUint8Array = new Uint8Array(file);
        const blob = new Blob([contentUint8Array], {
          type: "application/octet-stream",
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", dataDownload.data.nomeDoAnexo);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } else {
        throw new Error("Arquivo inexistente!");
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleVerificaClick = () => {
    // Abre/fecha o detalhe; a busca é feita no efeito apenas quando abrir
    handleClickOpenDetail();
  };

  useEffect(() => {
    const handledataDetail = async () => {
      try {
        // Busca somente quando abrir e se ainda não carregou
        if (openDetail && !dataDetail) {
          const retorno = await buscarDetailHistorico(idHistorico);
          // Novo formato esperado: { sucesso, historico, dados }
          setDataDetail(retorno?.dados || []);
        }
      } catch (error) {
        console.log(error);
      }
    };
    handledataDetail();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openDetail, idHistorico]);

  const handleClickOpenDetail = () => {
    setOpenDetail(!openDetail);
  };

  const handleSubtitleHistory = () => {
    switch (tipoHistorico) {
      case "Alteração solicitada":
        return "Campos solicitados";
      case "Resposta":
        return "Campos atualizados";
      default:
        return "Detalhes";
    }
  };

  return (
    <>
      <ModuleType tipo={tipoHistorico} onClick={() => handleVerificaClick()}>
        <div className={styles.textTipo}>{tipoHistorico}</div>
        <div className={styles.data__module}>{formatedData(dtCadastro)}</div>
      </ModuleType>
      <ContainerModule open={openDetail}>
        <div className={styles.header__moduleContainer}>
          <h1>
            {handleSubtitleHistory()}
          </h1>
        </div>
        <div className={styles.body__moduleContainer}>
          {Array.isArray(dataDetail)
            ? dataDetail.length > 0
              ? dataDetail.map((item) => (
                  <div className={styles.campo__body} key={item.idDadoHistorico}>
                    <span>{item.campo}</span>
                    {item.valor ? (
                      <span className={styles.valor__campo}>{item.valor}</span>
                    ) : item.nomeDoAnexo ? (
                      <div
                        className={styles.downloadBtn__campo}
                        onClick={() => handleDownload(item.idDadoHistorico)}
                      >
                        <DownloadIcon sx={{ fontSize: "18px" }} />
                        {item.nomeDoAnexo}
                      </div>
                    ) : (
                      "Campo não preenchido"
                    )}
                  </div>
                ))
              : "Nenhum detalhe encontrado"
            : "Carregando..."}
        </div>
      </ContainerModule>
    </>
  );
};

const HistoricoTimeline = ({ tipoCadastro, idUsuario, destaque }) => {
  const [openHistory, setOpenHistory] = useState(false);
  const [data, setData] = useState();

  useEffect(() => {
    if (destaque) {
      setOpenHistory(true);
    } else {
      setOpenHistory(false);
    }
  }, [destaque]);

  useEffect(() => {
    const handleData = async () => {
      let tipo;
      try {
        switch (tipoCadastro) {
          case "Cliente":
            tipo = "C";
            break;
          case "Parceiro":
            tipo = "P";
            break;
          case "Associado":
            tipo = "A";
            break;
        }
        const data = await buscarHistorico(tipo, idUsuario);
        setData(data.resumeHistorico);

        if (!data.resumeHistorico || data.resumeHistorico.length === 0) {
          throw new Error("Nenhum histórico encontrado");
        }
      } catch (error) {
        console.log(error);
      }
    };

    if (openHistory) {
      handleData();
    }
  }, [openHistory]);

  const handleClickOpenHistory = () => {
    setOpenHistory(!openHistory);
  };

  return (
    <>
      <section className={styles.mainContainer}>
        <div className={styles.historyBar} onClick={handleClickOpenHistory}>
          <div className={styles.titleModule__historyBar}>
            <Icon open={openHistory}>
              <HistoryIcon sx={{ fontSize: "2rem" }} />
            </Icon>
            <h1 className={styles.h1__historyBar}>Histórico de Interações</h1>
          </div>
        </div>

        <ContainerTimeLine open={openHistory}>
          {data && !(data.length === 0)
            ? data.map((moduleHistory) => (
                <ModuleTimeline
                  idHistorico={moduleHistory.idHistorico}
                  tipoHistorico={moduleHistory.tipoHistorico}
                  dtCadastro={moduleHistory.dtCadastro}
                />
              ))
            : "Nenhuma informação encontrada"}
        </ContainerTimeLine>
      </section>
    </>
  );
};

export default HistoricoTimeline;
